import { render } from "./TodayAppointments.vue?vue&type=template&id=1315a999&scoped=true&ts=true"
import script from "./TodayAppointments.vue?vue&type=script&lang=ts"
export * from "./TodayAppointments.vue?vue&type=script&lang=ts"

import "./TodayAppointments.vue?vue&type=style&index=0&id=1315a999&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1315a999"]])

export default __exports__